import React, { ReactElement } from 'react';
import WarningIcon from '../../icons/warning-icon';
import useStylesIconBlockWarning from './icon-block-warning.styles';

const IconBlockWarning: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isDisabled,
  } = props;

  const { classes } = useStylesIconBlockWarning();

  return (
    <WarningIcon className={!isDisabled ? classes.iconBlockWarning : undefined} />
  );
});

export default IconBlockWarning;
